import { CartItems } from "components/Cart/Items";
import { CartSummary } from "components/Cart/Summary";
import { CartProduct } from "components/Cart/Product";
// import { CartShipping } from "components/Cart/Shipping";
import "./Content.scss";

/**
 * Component: CartContent
 */
export function CartContent() {
  console.log("CartRemove mounted.");
  
  CartItems();
  CartSummary();
  CartProduct();
  // CartShipping();
}
